<template>
  <div class="">
      <div class="text-center main">
          <h5 class="font-active mb-0">Shop By Style</h5>
      </div>
        <swiper
            :onSwiper="onSwiper"
            :effect="'coverflow'"
            :centeredSlides="true"
            :loop="true"
            :spaceBetween="50"
            :grabCursor="true"
            :speed="500"
           
            :coverflowEffect="{
                rotate: 0,
                stretch: -90,
                depth: 550,
                modifier: 0.9,
                slideShadows: false,
                scale: 0.75
                }"
                :breakpoints="{
                1200: { slidesPerView: 3, slidesPerGroup: 1 },
                768: { slidesPerView: 2, slidesPerGroup: 1,spaceBetween:-20  },
                0: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween:-30 }
                }"
                :modules="[SwiperEffectCoverflow,SwiperAutoplay]"
                @swiper="onSwiper"
                ref="mySwiper"
                class="engSwiper mx-1"
                >
                  <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">
                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/solitaire.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/solitaire.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>
                              
                          </div>
                      </div>
                  </swiper-slide>
                  <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">

                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/sidestone.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/sidestone.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>


                          </div>
                      </div>
                  </swiper-slide>
                  <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">

                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/threestone.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/threestone.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>


                          </div>
                      </div>
                  </swiper-slide>
                  <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">

                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/vintage.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/vintage.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>


                          </div>
                      </div>
                  </swiper-slide>
                  <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">

                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/halo.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/halo.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>


                          </div>
                      </div>
                  </swiper-slide>
                  <!-- <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">

                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/threestone.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/threestone.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>


                          </div>
                      </div>
                  </swiper-slide> -->
                  <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">
                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/solitaire.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/solitaire.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>
                              
                          </div>
                      </div>
                  </swiper-slide>
                  <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">

                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/sidestone.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/sidestone.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>


                          </div>
                      </div>
                  </swiper-slide>
                  <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">

                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/threestone.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/threestone.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>


                          </div>
                      </div>
                  </swiper-slide>
                  <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">

                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/vintage.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/vintage.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>


                          </div>
                      </div>
                  </swiper-slide>
                  <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">

                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/halo.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/halo.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>


                          </div>
                      </div>
                  </swiper-slide>
                  <!-- <swiper-slide>
                      <div class="slide_box text-center">
                          <div class="img_box">

                              <picture>
                                  <source
                                      width="400"
                                      height="400"
                                      type="image/webp"
                                      src="/assets/new-eng-landing/shopbystyle/threestone.webp"
                                  />
                                  <img
                                      width="400"
                                      height="400"
                                      loading="lazy"
                                      class="thumb"
                                      src="/assets/new-eng-landing/shopbystyle/threestone.jpg"
                                      alt="Halo Engagement Rings"
                                  />
                              </picture>


                          </div>
                      </div>
                  </swiper-slide> -->
        </swiper>

        <div class="details text-center">
            <div class="detail_box">
              <div class="d-flex">
                <SvgHeaderSvg class="clickable" :type="'chev_left'" @click="goToPrevSlide"/>
                <h2 class="currentTitle mb-0"> 
                 
                   {{ currentStyleTitle }}
             
               </h2>
               <SvgHeaderSvg class="clickable"  :type="'chev_right'" @click="goToNextSlide"/>
              </div>

            </div>
            <p class='desc'>{{ currentStyleDescription }}</p>

              <div class="moreInfo">
                <div
                  class="modal_new"
                  :data-bs-target="currentModalTarget"
                  data-bs-toggle="modal"
                  @click="console.log('active',currentModalTarget)"
                >
                  MORE INFO
                </div>
              </div>
            <div class="banner_btn">
                <router-link class="anker radious_four btn-animation" :to="localePath({ name:'cyo-setting-list-ring',params:{ start_with: cyoLink }})">CREATE YOUR OWN</router-link>
                <router-link class="anker radious_four btn-animation" :to="localePath({ name: 'preset-listing', query:{ 'Style': predesignedLink, 'RefreshKey': predesignedLink }})">SHOP PRE-DESIGNED </router-link>
            </div>
        </div>
      <!-- MODAL -->
      <ClientOnly>
              <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" id="modal-halo" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">           
                      <div class="modal-body">
                        <div class="header_box" data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg" /></div>
                        <div class="row">
                          <div class="col-lg-4 col-md-12 text-center">
                            <picture>
                              <source width="280" height="280" type="image/webp" srcset="~/assets/home/style/halo.webp">
                              <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                                src="~/assets/home/style/halo.jpg" alt="Halo Engagement Rings">
                            </picture>
                          </div>
                          <div class="col-lg-8 col-md-12 content-container">
                            <h5 class="mb-0 font-active">Halo Engagement Rings</h5>
                            <h6 class="mb-0">Engagement rings with halos are crafted with round pavé or micro pavé set
                              diamonds circling the center diamond. These designs are an absolute beauty as the halos add
                              more sparkle to the ring while also putting the spotlight on the center gemstone and making it
                              appear larger. <br><br>
                              Some of these exquisite designs come with a hidden halo where the halo is crafted at the base
                              of the center stone, giving the ring an element of surprise. While halos around a round shaped
                              diamond are a classic choice, the recent trends also feature oval and pear shapes that tend to
                              gain wide popularity.
                            </h6>
                            <div class="banner_btn banner_btn_mod">
                              <router-link class="anker radious_four" :to="localePath('/engagement-rings')">CREATE YOUR OWN</router-link>
                              <router-link class="anker radious_four" :to="localePath('/fine-jewelry')">SHOP PRE-DESIGNED </router-link>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Teleport>
                <!-- 2 -->
              <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" id="modal-side-stone" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">                
                      <div class="modal-body">
                        <div class="header_box" data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg"/></div>
                        <!-- Vintage-->
                        <div class="row">
                          <div class="col-lg-4 col-md-12">
                            <picture>
                              <source width="280" height="280" type="image/webp"
                                srcset="~/assets/home/style/side_stone.webp">
                              <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                                src="~/assets/home/style/side_stone.jpg" alt="Side Stone Engagement Rings">
                            </picture>
                          </div>
                          <div class="col-lg-8 col-md-12 content-container">
                            <h5 class="mb-0 font-active">Side Stone Engagement Rings</h5>
                            <h6 class="mb-0">Side stone diamond engagement rings are crafted with a set of diamonds on the
                              sides of the center gemstone. The side diamonds act as a perfect embellishment on the ring’s
                              shank, enhancing the appearance of the center diamond and making it look bigger.
                              <br><br>
                              The accent stones of these rings are usually set in a pavé or micro pavé setting. However,
                              french split, scalloped prongs, and channel settings have also become a popular choice in this
                              engagement ring style.
                              <br><br>
                              The most popular styles in side stone diamond rings are full eternity and half eternity rings.
                              The more unique rings among these feature double, twisted, or split shanks with small diamonds
                              on them.
                            </h6>
                            <div class="banner_btn banner_btn_mod">
                              <router-link class="anker radious_four" :to="localePath('/engagement-rings')">CREATE YOUR OWN</router-link>
                              <router-link class="anker radious_four" :to="localePath('/fine-jewelry')">SHOP PRE-DESIGNED </router-link>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Teleport>  
                <!-- 3 -->
              <Teleport  to="#teleports">   
                <div class="modal fade" data-bs-backdrop="true" id="modal-solitaire" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">                   
                      <div class="modal-body">
                        <div class="header_box" data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg" /></div>
                        <!-- solitare-->
                        <div class="row">
                          <div class="col-lg-4 col-md-12">
                            <picture>
                              <source width="280" height="280" type="image/webp" srcset="~/assets/home/style/solitaire.webp">
                              <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                                src="~/assets/home/style/solitaire.jpg" alt="Solitaire Engagement Rings">
                            </picture>
                          </div>
                          <div class="col-lg-8 col-md-12 content-container">
                            <h5 class="mb-0 font-active">Solitaire Engagement Rings</h5>
                            <h6 class="mb-0">Solitaire engagement rings are a versatile and classic style with a single
                              sparkling diamond in the center. Their quintessential design puts all the focus on the center
                              gemstone.
                              <br><br>
                              Customizable in every way, you can choose your ideal lab diamond shape, metal type, and metal
                              color based on your preferences to craft your perfect solitaire ring. This style is
                              traditionally associated with a round diamond; however, incorporating fancy-shaped diamonds
                              such as hearts or ovals has been a popular contemporary trend.
                              <br><br>
                              Solitaire engagement rings typically feature plain solid metal bands. Nevertheless, they may
                              also have fancy bands in flat, thin, knife edge, and sometimes crisscross or twisted styles.
                            </h6>
                            <div class="banner_btn banner_btn_mod">
                              <router-link class="anker radious_four" :to="localePath('/engagement-rings')">CREATE YOUR OWN</router-link>
                              <router-link class="anker radious_four" :to="localePath('/fine-jewelry')">SHOP PRE-DESIGNED </router-link>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Teleport>  
                <!-- 4 -->
              <Teleport  to="#teleports">   
                <div class="modal fade" data-bs-backdrop="true" id="modal-three-stone" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">                 
                      <div class="modal-body">
                        <div class="header_box" data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg" /></div>
                        <!--Three Stone E-->
                        <div class="row">
                          <div class="col-lg-4 col-md-12">
                            <picture>
                              <source width="280" height="280" type="image/webp"
                                srcset="~/assets/home/style/three_stone.webp">
                              <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                                src="~/assets/home/style/three_stone.jpg" alt="Three Stone Engagement Rings">
                            </picture>
                          </div>
                          <div class="col-lg-8 col-md-12 content-container">
                            <h5 class="mb-0 font-active">Three Stone Engagement Rings</h5>
                            <h6 class="mb-0">Three stone diamond engagement rings are modern-day designs with a vintage
                              touch. Crafted with three main diamonds on the shank, each diamond symbolizes the couple's
                              eternal relationship, representing the past, present & forever of their journey.
                              <br><br>
                              Classic three stone engagement rings feature two round diamonds on each side of the center
                              stone. However, the contemporary trends feature a mix of traditional & modern-day artistry,
                              crafted with oval, emerald, or step cut diamonds like trapeziums and baguettes on both sides
                              of the center diamond.
                            </h6>
                            <div class="banner_btn banner_btn_mod">
                              <router-link class="anker radious_four" :to="localePath('/engagement-rings')">CREATE YOUR OWN</router-link>
                              <router-link class="anker radious_four" :to="localePath('/fine-jewelry')">SHOP PRE-DESIGNED </router-link>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Teleport>  
                <!-- 5 -->
              <Teleport  to="#teleports">   
                <div class="modal fade" data-bs-backdrop="true" id="modal-vintage" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-body">
                        <div class="header_box" data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg" /></div>
                        <!-- Vintage-->
                        <div class="row">
                          <div class="col-lg-4 col-md-12">
                            <picture>
                              <source width="280" height="280" type="image/webp" srcset="~/assets/home/style/vintage.webp">
                              <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                                src="~/assets/home/style/vintage.jpg" alt="Halo Engagement Rings">
                            </picture>
                          </div>
                          <div class="col-lg-8 col-md-12 content-container">
                            <h5 class="mb-0 font-active">Vintage Engagement Rings</h5>
                            <h6 class="mb-0">
                              Vintage engagement rings are for those with a penchant for the beauty of the classic era.
                              These designs feature a rich aesthetic with intricate and detailed features that span through
                              the ripples of time.
                              <br><br>
                              While classic vintage rings usually feature Milgrain or Filigree artwork on their shank, some
                              modern ones may feature a twisted shank with accent diamonds placed aesthetically.
                              <br><br>
                              Inspired by the Victorian, Edwardian, Art Deco, and Retro eras, there is a design for every
                              vintage lover looking for the perfect lab diamond engagement ring!
  
                            </h6>
                            <NuxtLink class="modal_link radious_four"
                              :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'vintage-engagement-rings' } })">
                              Shop Vintage Engagement Rings</NuxtLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Teleport>  
      </ClientOnly>

  </div>
</template>

<script setup>
const swiperInstance = ref(null);

const activeSlide = ref(0);
const localePath = useLocalePath()
const styles = [
      { title: "Solitaire", description: "A timeless and enduring style featuring a single centre diamond.",cyoLink:'solitaire-engagement-rings', predesignedLink:'Solitaire' },
      {title: "Side Stone", description: "A stunning and elegant style crafted with sparkling side diamonds." ,cyoLink: 'side-stone-engagement-rings',predesignedLink:'Side-stone'},
      {title: "Three Stone", description: "A classic style symbolising the past, present, and forever of love.",cyoLink:'three-stone-engagement-rings',predesignedLink:'Three-Stone'},
      {title: "Vintage", description: "A treasured style inspired by the detailed designs of the vintage era." ,cyoLink:'vintage-engagement-rings',predesignedLink:'Vintage'},
      { title: "Halo", description: "Glamorous style with a centre stone surrounded by small diamonds.",cyoLink:'halo-engagement-rings',predesignedLink:'Halo'},
      // {title: "Three Stone", description: "A classic style symbolising the past, present, and forever of love.",cyoLink:'three-stone-engagement-rings',predesignedLink:'Three-Stone'},
      { title: "Solitaire", description: "A timeless and enduring style featuring a single centre diamond.",cyoLink:'solitaire-engagement-rings', predesignedLink:'Solitaire' },
      {title: "Side Stone", description: "A stunning and elegant style crafted with sparkling side diamonds." ,cyoLink: 'side-stone-engagement-rings',predesignedLink:'Side-stone'},
      {title: "Three Stone", description: "A classic style symbolising the past, present, and forever of love.",cyoLink:'three-stone-engagement-rings',predesignedLink:'Three-Stone'},
      {title: "Vintage", description: "A treasured style inspired by the detailed designs of the vintage era." ,cyoLink:'vintage-engagement-rings',predesignedLink:'Vintage'},
      { title: "Halo", description: "Glamorous style with a centre stone surrounded by small diamonds.",cyoLink:'halo-engagement-rings',predesignedLink:'Halo'},
      // {title: "Three Stone", description: "A classic style symbolising the past, present, and forever of love.",cyoLink:'three-stone-engagement-rings',predesignedLink:'Three-Stone'},
      
];
const loading = ref(true);

const goToNextSlide =()=>{        
    if (swiperInstance.value) {
    swiperInstance.value.slideNext(); 
    }
}

const goToPrevSlide = () => {
    if (swiperInstance.value) {
        swiperInstance.value.slidePrev();
    }
}

const cyoLink = computed(()=>{
  if(swiperInstance.value?.activeIndex){
    return styles[activeSlide.value]?.cyoLink
  }
})

const predesignedLink = computed(()=>{
  if(swiperInstance.value?.activeIndex){
    return styles[activeSlide.value]?.predesignedLink
  }
})
const currentStyleTitle = computed(() => {
  const title = styles[activeSlide.value]?.title;
  return title;
});


const currentStyleDescription = computed(() => {
  return styles[activeSlide.value]?.description;
});
const mySwiper = ref(null);


function onSwiper(swiper) {
  swiperInstance.value = swiper;
  swiper.on('slideChange', () => {
      activeSlide.value = swiper.realIndex;  

});
loading.value=false
}

const currentModalTarget = computed(() => {
  const title = styles[activeSlide.value]?.title;
  return `#modal-${title.replace(/\s+/g, '-').toLowerCase()}`;
});

// watch(activeSlide, (newValue) => {
//   console.log('Active slide changed:', newValue, 'Current title:', currentStyleTitle.value);
// });

function goToSlide(index) {    
// if (swiperInstance.value) {
//     if (swiperInstance.value.params.loop) {
//         swiperInstance.value.slideToLoop(index);
//     } else {
//         swiperInstance.value.slideTo(index); 
//     }
//     activeSlide.value = index;
//     }
}

onMounted(() => {
  if (mySwiper.value) {
  } else {
    console.warn('Swiper instance not available at mounted');
  }
});
</script>

<style scoped>
 
  .largesvg{
    cursor: pointer;
    transform: scale(1.3);
  }

  .moreInfo ,.clickable{
    cursor: pointer;
  }
  .main h5 {
      font-size: 32px;
      color: #212529;
  }

  h2{
      color: #405955;
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 3px;
      text-align: center;
      text-transform: uppercase;
      cursor: pointer;
  }
  .currentTitle {
    min-width: 200px; 
    text-align: center; 
    white-space: nowrap; 
    user-select: none;
  }

  .modal_new{
      text-decoration: underline;
      color: #668B84;
      margin: 0 0 24px;
      letter-spacing: 2px;
  }
  .main p {
      font-size: 16px;
      color: #606060;
  }
  .desc {
      font-size: 16px;
      color: #606060;
      margin: 12px 0;
      max-width: 600px;
      user-select: none;
  }
  .banner_btn.banner_btn_mod {
    justify-content: flex-start;
}

  .slide_box {
      border-radius: 4px;
      cursor: pointer
  }

  .details {
      display: flex;
      flex-direction: column;
      align-items: center;
  }

  .banner_btn {
      display: flex;
      justify-content: center;
  }

  .banner_btn a {
      padding: 12px 20px;
      margin-right: 3%;
      font-size: 14px;
      min-width: 210px;
      text-align: center;
      color: #353535;
      letter-spacing: 1.5px;
      font-weight: 700;
      text-transform: uppercase;
      border: 1.5px solid #353535;
  }

  .modal-content{
    padding: 2%;
    border-radius: 8px;
}
  @media (max-width: 767px) {
    .content-container{
      max-height: 220px; 
      overflow: scroll
    }

    .details{
      max-width: 80%;
      margin: auto;
    }
  .modal-body{
    text-align: center;
  }
  .main h5 {
      font-size: 24px;
  }

  h2{
      font-size: 16px;
  }

  .details p{
      font-size: 14px
  }

  .main p {
      font-size: 14px;
  }

  .detail_box .money {
      font-size: 14px;
  }

  .detail_box p {
      font-size: 14px;
  }

  /* .slide_box {
      padding: 12px 13px;
  } */

  .main {
      margin: 0 16px;
  }
  /* .banner_btn a{
      margin-right: 0
  }
  .banner_btn{
      display: flex;
      justify-content: center;
      gap: 5px;
      flex-direction: column;
      padding: 0 15%;
  } */

  .banner_btn a {
      margin-right: 0;
      width: 100%;
      padding: 12px 20px;
      font-size: 14px;
      text-align: center;
  }

  .banner_btn {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      gap: 8px; 
      padding: 0 15%;
      width: 100%; 
  }
  }

  .modal_link {
    display: inline-block;
    font-size: 14px;
    color: #000;
    font-weight: 600;
    border: 1px solid #000;
    padding: 9px 15px;
    background: #fff;
  }
  h6{
      color: #6a6161;
      padding: 2% 0 3%;
      line-height: 1.4;
  }
  .header_box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

.header_box span {
  padding: 0;
}
/* .modal_new {
display: none;
}
:global(.modal_new.open_modal) {
  display: inline-block;
} */
 
.btn-animation span{
  position: relative;
  left: 0px;
  transition: all 0.3s ease-out;
}

.btn-animation:hover span {
    left: -12px;
}

.btn-animation::after{
  content: '';
  width: 6px;
  height: 11px;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translate(-15px, -50%);
  background-image: url('@/assets/svg/arrow-black.svg');
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0;
  transition: all 0.3s ease-out;
}

.btn-animation:hover::after {
    opacity: 1;
}

</style>